import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import { motion } from 'framer-motion';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Feed from '../feed';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { DOMAIN } from '../../config';
import { Box, DialogContent, Tabs, Tab, styled } from '@mui/material';
import CustomizedProgressBars from '../common/loading';
import SearchOffIcon from '@mui/icons-material/SearchOff';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export default function TopVideosDialogg({ setOpenMovies, openMovies, matches, chipTitle }) {
  const [latest, setLatest] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [stopLoad, setStopLoad] = useState(false);
  const [empty, setEmpty] = useState(false);
  const [finished, setFinished] = useState(false);
  const [period, setPeriod] = useState('week'); // 默认一周
  const dialogRef = useRef(null);
  const touchStartRef = useRef(0);
  

  const periods = [
    { label: '今天', value: 'day' },
    { label: '一周', value: 'week' },
    { label: '本月', value: 'month' },
    { label: '一年', value: 'year' },
  ];

  const handleSwipe = (event) => {
    const touchEndX = event.changedTouches[0].clientX;
    const swipeDistance = touchStartRef.current - touchEndX;
    const flag =
      event.target.className.includes('MuiBox-root') ||
      event.target.className.includes('MuiTypography-root') ||
      event.target.className.includes('swiper-slide') ||
      event.target.className === '';

    if (swipeDistance > 120 && !flag) {
      setOpenMovies(false);
    }
  };

  const handleTouchStart = (event) => {
    event.stopPropagation();
    touchStartRef.current = event.touches[0].clientX;
  };

  const handleClose = () => setOpenMovies(false);

  const fetchData = (pageNum = 1, periodValue = period) => {
    setLoading(true);
    fetch(`${DOMAIN}player/getTopVideos?period=${periodValue}&page=${pageNum}`)
      .then((res) => res.json())
      .then((data) => {
        if (!data || data.length === 0) {
          if (pageNum === 1) setEmpty(true);
          setStopLoad(true);
          setFinished(true);
        } else {
          setEmpty(false);
          if (pageNum === 1) {
            setLatest(data);
          } else {
            setLatest((prev) => [...prev, ...data]);
          }
          setStopLoad(false);
          setPage(pageNum);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setStopLoad(true);
      });
  };

  const handleScroll = () => {
    if (stopLoad) return;
    const { scrollTop, scrollHeight, clientHeight } = dialogRef.current;
    if (scrollTop + 1 + clientHeight >= scrollHeight) {
      fetchData(page + 1);
    }
  };

  const handleChangePeriod = (event, newValue) => {
    setPeriod(newValue);
    setPage(1);
    setStopLoad(false);
    setFinished(false);
    setEmpty(false);
    setLatest(null);

    if (dialogRef.current) {
      dialogRef.current.scrollTop = 0; // 滚动到顶部
    }

    fetchData(1, newValue);
  };

  useEffect(() => {
    if (openMovies) {
      fetchData(1, period);
      const dialogElement = dialogRef.current;
      if (dialogElement) dialogElement.addEventListener('scroll', handleScroll);

      return () => {
        setStopLoad(false);
        setEmpty(false);
        setPage(1);
        if (dialogElement) dialogElement.removeEventListener('scroll', handleScroll);
      };
    }
  }, [openMovies]);

  return (
    <Box>
      <Dialog
        fullScreen
        open={openMovies}
        onClose={handleClose}
        TransitionComponent={Transition}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleSwipe}
        PaperProps={{
          onTouchStart: handleTouchStart,
          onTouchEnd: handleSwipe,
        }}
      >
        <AppBar
  position="sticky"
  elevation={0}
  sx={{
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    backgroundColor: 'rgba(255,255,255,0.25)',
    color: '#000',
  }}
>
  <Toolbar sx={{ minHeight: 45, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <motion.div
      initial={{ x: '100vw', opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
    >
      <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
        <CloseIcon fontSize="small" />
      </IconButton>
      <Typography variant="subtitle1" sx={{ fontWeight: 500, fontSize: 16 }}>
        {chipTitle}
      </Typography>
    </motion.div>

    {/* Tabs 放在导航右边或者下方都可以 */}
   <Tabs
  value={period}
  onChange={handleChangePeriod}
  textColor="inherit"
  indicatorColor="primary"
  variant="scrollable"   // 允许超出宽度滚动
  scrollButtons="auto"
  sx={{
    marginLeft: 2,
    minHeight: 32,
  }}
>
  {periods.map((p) => (
    <Tab
      key={p.value}
      label={p.label}
      value={p.value}
      sx={{
        minHeight: 32,
        minWidth: 55,        // 压缩最小宽度
        paddingX: 1,        // 左右内边距更小
        fontSize: 12,
        textTransform: 'none',
        whiteSpace: 'nowrap' // 文字不换行
      }}
    />
  ))}
</Tabs>


  </Toolbar>
</AppBar>


        <DialogContent
  ref={dialogRef}
  onScroll={handleScroll}
  style={{
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: 0,
    paddingTop: 90, // AppBar(45px) + Tabs(约45px)，根据实际高度可调整
    overflowY: 'auto',
  }}
>

          {latest && (
            <Feed
              matches={matches}
              latest={latest}
              setLatest={setLatest}
              isRemark={false}
              title="热播排行"
              fetchUrl={`${DOMAIN}player/getTopVideos?period=${period}`}
            />
          )}
          {empty && (
            <Box sx={{ display: 'flex', justifyContent: 'center', flexFlow: 'row', padding: '200px 0', color: '#999' }}>
              <SearchOffIcon />
              <Typography variant="h6" fontSize={14}>
                没有此内容，我们会尽快发布...
              </Typography>
            </Box>
          )}
          {loading && <CustomizedProgressBars />}
          {finished && (
            <Typography
              variant="h6"
              sx={{ fontSize: 12, paddingBottom: 20, textAlign: 'center', color: '#888', fontWeight: 350 }}
            >
              已经是最后一条了～
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}

const BlinkingButton = styled(Button)(({ theme }) => ({
  animation: 'blinking 1.8s infinite',
  '@keyframes blinking': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.7 },
    '100%': { opacity: 1 },
  },
}));
